<h1 mat-dialog-title>{{data.label}}</h1>
<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{data.label}}</mat-label>
      <input matInput formControlName="guidInput">
      <mat-error *ngIf="form.controls['guidInput'].invalid">Invalid GUID format</mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [disabled]="form.invalid" (click)="onSubmit()">Ok</button>
</div>
